/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ConversationListResponse, GetConversationsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getConversations: build.query<ConversationListResponse, GetConversationsApiArg>({
      query: (queryArg) => ({
        method: 'GET',
        params: {
          limit: queryArg.limit,
          page: queryArg.page,
          search: queryArg.search,
          status: queryArg.status,
        },
        url: `/v1/conversations`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getConversationsApi };
export const { useGetConversationsQuery, useLazyGetConversationsQuery } = injectedRtkApi;
